import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useCompanies from '../../../hooks/api-calls/useCompanies';
import useRoles from '../../../hooks/api-calls/useRoles';
import { FilterOptions } from '../../../hooks/useFilters';

interface UsersFiltersProps {
    updateFilters: (filters: any) => void
    filters: FilterOptions
}

const UsersFilters: React.FC<UsersFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getRolesList } = useRoles();
    const { getCompaniesList } = useCompanies();

    // RENDER

    return (
        <>
            <CustomTextDelayInput
                id="name"
                label="Nombre"
                placeholder='Buscar por nombre'
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="email"
                label="Correo electrónico"
                placeholder='Buscar por correo electrónico'
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomSelect
                isSearchable
                id={'active'}
                label="Estado"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ active: null });
                        return;
                    }
                    updateFilters({ active: e.value });
                }}
                value={filters.filter_filters?.active !== null
                    ? { label: filters.filter_filters?.active ? 'Activo' : 'Desactivado', value: filters.filter_filters?.active }
                    : { label: 'Todos', value: 'null' }}
            />

            <CustomSelect
                isSearchable
                isMulti
                id={'roleId'}
                label="Rol"
                options={getRolesList()}
                onChange={(e: any) => { updateFilters({ roles: e.map((rol: any) => rol.value) }) }}
                value={
                    filters.filter_filters?.roles
                        ? getRolesList().filter((rol: any) => filters.filter_filters?.roles.includes(rol.value))
                        : []
                }
                display={userCan('list', 'role')}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Último acceso", value: "lastLogin" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (between_dates && filters_between_dates !== between_dates) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />
            )}
        </>
    );
};

export default UsersFilters;